import { useQuery, useQueryClient } from "@tanstack/react-query";
import "./NotificationScreen.css";
import LoadingDisplay from "components/reusable/LoadingDisplay";
import { isLoggedIn } from "utilities/js/ActionLibrary";
import { getNotifications } from "utilities/js/callouts/CalloutFactory";
import { useEffect, useRef } from "react";
import NotificationPrompt from "components/reusable/NotificationPrompt";
import { markNotificationsAsRead } from "utilities/js/callouts/CalloutFactory";
import NotificationItem from "./NotificationItem";

const NotificationScreen = props => {
    const queryClient = useQueryClient();
    const markedNotificationsAsRead = useRef(false);

    const notificationResponse = useQuery({
        queryKey: ['notifications'],
        queryFn: getNotifications,
        staleTime: 1000 * 60,
        enabled: isLoggedIn()
    });
    const unreadNotificationsResponse = useQuery({
        queryKey: ['unreadNotifications'],
        queryFn: () => getNotifications({readStatus: false}),
        staleTime: Infinity,
        enabled: isLoggedIn()
    });

    //When we land on the notification screen, all new notifications should be bold
    //And we should mark them all as "read" on the server side and clear the unreadNotifications React Query
    useEffect(() => {
        if(unreadNotificationsResponse.isSuccess && unreadNotificationsResponse.data?.length > 0 && notificationResponse.isSuccess){
            if(!markedNotificationsAsRead.current){
                    let idsToUpdate = unreadNotificationsResponse.data.map(notification => {
                        return notification._id;
                    })
                    markNotificationsAsRead({ids: idsToUpdate}).then(response => {
                        markedNotificationsAsRead.current = true;                        
                        queryClient.invalidateQueries({ queryKey: ['unreadNotifications'] })
                        // unreadNotificationsResponse.refetch();
                    
                    }).catch(error => {
                        console.log('Something went wrong marking notifications as read');
                        console.log(error);
                    })
                }
            }
    }, [notificationResponse])

    function getNotificationContent(){

        if(notificationResponse.isSuccess && notificationResponse.data?.length > 0){
            const notificationList = notificationResponse.data.map(notification => {
                return (<NotificationItem notification={notification}></NotificationItem>)
            })
            return notificationList;
    
        }else if(notificationResponse.isFetching || notificationResponse.isLoading){
            return (<LoadingDisplay isLoading={notificationResponse.isFetching || notificationResponse.isLoading}></LoadingDisplay>)
        }else{
            return (<div className="notification-list-empty">There are no notifications to display</div>)
        }
    }

    return (
        <div className="notification-list">
            <NotificationPrompt notifications={notificationResponse.data}></NotificationPrompt>
            {getNotificationContent()}
        </div>
    )
    

}

export default NotificationScreen;